// extracted by mini-css-extract-plugin
export var button = "_jg-2";
export var card = "_jg-0";
export var closeButtonContainer = "_jg-3";
export var iconContainer = "_jg-1";